import '../Css/Adresses.css';
import json from "./adresses.json";
import AdresseContent from "./AdresseContent.js";
import LuneDeMiel from './LuneDeMiel.js';

export default function Adresses() {

  return (
    
    <div id='Adresses' className='adresses-container'>
      <div className="section-title">
        <div className="title"></div>
        <div className="swirls">
          <img className="swirls-img" alt="" src="./Images/Icons/swirl_left.png"></img>
          <img className="swirls-img" alt="" src="./Images/Icons/swirl.png"></img>
        </div>
      </div>
      <div className='adresses-row'>
       { json.adresses.map((item,i) => (
          <AdresseContent 
            key={item.id} 
            orientation={i} 
            img={item.img} 
            imgAlt={item.img} 
            title={item.title} 
            hour={item.hour} 
            maps={item.maps} 
            location={item.location} 
            description={item.description}>
          </AdresseContent>
        ))}
        <LuneDeMiel></LuneDeMiel>
      </div>
    </div>
    
  );
}